module.exports = __webpack_public_path__ + "static/img/Store-4.0e6e63bb.png";